import { FC } from 'react';
import './StepNavigation.scss';

interface StepNavigationProps {
    onBack: () => void;
    onNext: () => void;
    nextLabel?: string;
    // Versão curta exibida só no mobile (ex.: "Próxima Etapa (Endereço)" -> "Próximo").
    nextLabelMobile?: string;
    nextDisabled?: boolean;
    nextLoading?: boolean;
    hideBack?: boolean;
    extraButton?: {
        label: string;
        onClick: () => void;
        disabled?: boolean;
        variant?: 'primary' | 'ghost';
    };
    secondExtraButton?: {
        label: string;
        onClick: () => void;
        disabled?: boolean;
    };
}

const StepNavigation: FC<StepNavigationProps> = ({
    onBack,
    onNext,
    nextLabel = 'Próximo',
    nextLabelMobile,
    nextDisabled = false,
    nextLoading = false,
    hideBack = false,
    extraButton,
    secondExtraButton,
}) => {
    // No grid 2 colunas do mobile, se sobrar um botão sozinho na última linha
    // (total ímpar) ele fica preso na coluna esquerda e o texto quebra — nesse
    // caso o botão "next" (sempre o último) ocupa a linha toda e centraliza.
    const totalButtons = (hideBack ? 0 : 1) + (extraButton ? 1 : 0) + (secondExtraButton ? 1 : 0) + 1;
    const nextAlone = totalButtons % 2 !== 0;

    return (
        <div className="step-navigation">
            {!hideBack && (
                <button
                    className="step-navigation__back"
                    onClick={onBack}
                >
                    Voltar
                </button>
            )}
            <div className="step-navigation__actions">
                {extraButton && (
                    <button
                        className={extraButton.variant === 'ghost' ? 'step-navigation__back' : 'step-navigation__next'}
                        onClick={extraButton.onClick}
                        disabled={extraButton.disabled}
                    >
                        {extraButton.label}
                    </button>
                )}
                {secondExtraButton && (
                    <button
                        className="step-navigation__next"
                        onClick={secondExtraButton.onClick}
                        disabled={secondExtraButton.disabled}
                    >
                        {secondExtraButton.label}
                    </button>
                )}
                <button
                    className={`step-navigation__next${nextAlone ? ' step-navigation__next--full' : ''}`}
                    onClick={onNext}
                    disabled={nextDisabled || nextLoading}
                >
                    {nextLoading ? <span className="step-navigation__spinner" /> : nextLabelMobile ? (
                        <>
                            <span className="step-navigation__next-label--full">{nextLabel}</span>
                            <span className="step-navigation__next-label--mobile">{nextLabelMobile}</span>
                        </>
                    ) : nextLabel}
                </button>
            </div>
        </div>
    );
};

export default StepNavigation;
